import React, { Component } from "react";
import { Subscribe } from "unstated";
import { withTranslation } from "react-i18next";

import stringHelper from "../../utils/helpers/stringHelper";
import deviceHelper from "../../utils/helpers/deviceHelper";
import StateContainer from "../../state/StateContainer";

import HotspotFilters from "../HotspotFilters/HotspotFilters";
import Legend from "../Legend/Legend";
import StateButtonArray from "../Buttons/StateButtonArray/StateButtonArray";
import DisplayWrapper from "../DisplayWrapper/DisplayWrapper";
import DefaultButton from "../Buttons/DefaultButton/DefaultButton";
import StarButton from "../Buttons/StarButton/StarButton";

import "./Navbar.css";

class Navbar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen: false,
			carouselNavbarSettings: {
				dots: false,
				infinite: true,
				arrows: false,
				speed: 200,
				slidesToShow: 5,
				slidesToScroll: 1,
				/* className: "navbar--slick", */
				vertical: true,
				verticalSwiping: true,
			},
		};
	}

	/**
	 * Returs the id of the state to be scrolled to
	 * @param stateName Name of the state to filter by
	 * @param states Array of all states
	 */
	async getStateBeingScrolledTo(stateName, states) {
		for (let i = 0; i < states.length; i++) {
			const state = states[i];
			if (state.name === stateName) {
				return state.id;
			}
		}
		return null;
	}

	/**
	 * Scrolls to the height of the current active button.
	 * @param customButtons Array of buttons that are displayed in the navbar
	 * @param currentState Index of current floor/state
	 * @param states Array of all states
	 */
	async updateButtonContainerScroll(customButtons, currentState, states) {
		const buttonContainer = document.getElementById("scrollbar");
		const buttonsInNavbar = customButtons?.filter(
			(button) => !button.isDefault
		);

		for (let index = 0; index < buttonsInNavbar.length + 1; index++) {
			const button = buttonsInNavbar[index];
			if (button === undefined || button.actions[0] === undefined) return;

			const idOfState = await this.getStateBeingScrolledTo(
				button.actions[0].parameter,
				states
			);
			if (idOfState === null) return;

			if (idOfState === currentState) {
				const scrollToHeight =
					(buttonsInNavbar.length - 1) * 64 - index * 64;
				buttonContainer.scrollTo({
					top: scrollToHeight,
					left: 0,
					behavior: "smooth",
				});
			}
		}
	}

	render() {
		const isMobile = deviceHelper.isMobileDevice();
		const { t } = this.props;
		const sideMenuContainerBackground = isMobile
			? ""
			: stringHelper.removeAplhaFromColor(
					this.props.unstated.state.menuColor
			  );

		return !this.props.unstated.state.menuVisibility ? null : (
			<div
				id={"side-menu"}
				className={"side__menu"}
				style={{
					transform: `translateX(${
						this.props.unstated.state.isSideBarOpen
							? "0px"
							: "-282px"
					})`,
				}}
			>
				<div
					className="side__menu--logo_container"
					style={{
						backgroundColor: sideMenuContainerBackground,
					}}
				>
					<div
						className="logo-wrap"
						style={{
							backgroundColor: this.props.unstated.menuColor,
						}}
					>
						<div
							className="side__menu--logo"
							style={{
								backgroundImage: `Url(${
									this.props.unstated.state.projectLogo
										? this.props.unstated.state.projectLogo
										: ""
								})`,
							}}
						></div>
						<div className="side__menu-star_icon">
							<StarButton />
						</div>
						{isMobile ? (
							<></>
						) : (
							<button
								className="open-menu-button"
								onClick={() => {
									this.props.unstated.toggleSideMenu();
								}}
							>
								<p>{t("MENU").toUpperCase()}</p>
								<br />
								<img
									src="/design/new-exports/up_navbar_arrow.png"
									alt=""
									style={{
										transform: `rotate(${
											!this.props.unstated.state
												.isSideBarOpen
												? 90
												: -90
										}deg)`,
									}}
								/>
							</button>
						)}
					</div>
					<DisplayWrapper displayParameter="isInvestorLogoShown">
						<div
							className="side__menu--image"
							style={{
								backgroundImage: `Url(${this.props.unstated.state.clientLogo})`,
							}}
						></div>
					</DisplayWrapper>
				</div>
				<div
					className="filter-column"
					style={{
						backgroundColor: this.props.unstated.state.menuColor,
					}}
				>
					<Legend
						availableFilters={
							this.props.unstated.state.availableFilters
						}
            apartmentReservedColor={this.props.unstated.state.apartmentReservedColor}
						hotspots={this.props.unstated.state.hotspots}
					/>
					<DisplayWrapper displayParameter="isFilterMenuShown">
						<HotspotFilters
							currentQuadrature={
								this.props.unstated.state.quadratureValues
							}
							currentState={
								this.props.unstated.state.currentState
							}
							currentPrices={
								this.props.unstated.state.priceValues
							}
						/>
					</DisplayWrapper>
				</div>
				<div className="navbar">
					<div
						className="up__button-container"
						style={{
							backgroundColor:
								this.props.unstated.state.menuColor,
						}}
					>
						<DefaultButton
							buttonClass="back-button"
							buttonName="Back"
						/>
						<button
							className="up_button"
							onClick={async () => {
								await this.props.unstated.increaseCurrentFloor();
								this.updateButtonContainerScroll(
									this.props.unstated.state.customButtons,
									this.props.unstated.state.currentState,
									this.props.unstated.state.jsonData.states
								);
							}}
						></button>
					</div>
					<StateButtonArray
						customButtons={this.props.unstated.state.customButtons}
					/>
					<div
						className="down__button-container"
						style={{
							backgroundColor:
								this.props.unstated.state.menuColor,
						}}
					>
						<button
							className="down_button"
							onClick={async () => {
								await this.props.unstated.decreaseCurrentFloor();
								this.updateButtonContainerScroll(
									this.props.unstated.state.customButtons,
									this.props.unstated.state.currentState,
									this.props.unstated.state.jsonData.states
								);
							}}
						></button>

						{this.props.unstated.state.magLogoVisible && (
							<img
								className="navbar__small-bottom-logo"
								src={
									this.props.unstated.state
										.navbarScrollbarLogo
								}
								alt="navbar small logo"
							/>
						)}
					</div>
				</div>
			</div>
		);
	}
}

function NavbarWithUnstated(props) {
	return (
		<Subscribe to={[StateContainer]}>
			{(unstated) => <Navbar {...props} unstated={unstated} />}
		</Subscribe>
	);
}

export default withTranslation()(NavbarWithUnstated);
